var React = require('react');

function Account (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16,3A13,13,0,1,0,29,16,13,13,0,0,0,16,3Zm0,3.9a3.9,3.9,0,1,1-3.9,3.9A3.895,3.895,0,0,1,16,6.9Zm0,18.46a9.361,9.361,0,0,1-7.8-4.186c.039-2.587,5.2-4,7.8-4s7.761,1.417,7.8,4A9.361,9.361,0,0,1,16,25.36Z","transform":"translate(-3 -3)","fill":"#abaaa6"}));
}

Account.defaultProps = {"width":"26","height":"26","viewBox":"0 0 26 26"};

module.exports = Account;

Account.default = Account;
